'use strict';

const componentName = 'pmtLocationNetworkStatus';

function Controller(
	$scope,
	$http,
	$i18next,
	$stateParams,
	auth,
	pmtEnabledNetworksService,
	locationDataService
) {
	const site = $stateParams.site;
	const placeId = $stateParams.placeId;
	const adminUrl = window.pmtEnv.urls.admin;

	this.site = site;
	this.userIsAdmin = auth.user.isAdmin;
	this.selectedSite = auth.user.selectedSite;
	this.placeId = placeId;
	this.loading = true;
	this.isBingPublished = false;
	this.workerLogPage = `/listings/${site}/workerLog/items?filter=%7B"filterDefinition":%5B%7B"property":"locations","value":%5B"${placeId}"%5D%7D%5D%7D`;
	this.appleClaimPage = `/listings/${site}/claim/apple`;
	this.appleNotificationsPage = `${adminUrl}appleNotifications?searchQuery=${placeId}`;
	this.appleOAuthConnected = false;
	this.refetchingGoogle = false;
	const getAppleBusiness = businessId => {
		if (!businessId) {
			return Promise.resolve(null);
		}
		const url = `api/${encodeURI(site)}/apple/claim/businesses`;
		return $http
			.get(url)
			.then(response => response.data.find(business => business.businessId === businessId));
	};

	const getAppleFeedback = locationId => {
		if (!locationId) {
			return Promise.resolve(null);
		}
		const url = `api/${encodeURI(site)}/apple/claim/getLatestFeedback/${encodeURI(locationId)}`;
		return $http.get(url).then(response => response.data || null);
	};

	const bindPlace = res => {
		this.place = res.data;
		this.appleOAuthConnected = !!this.place['apple']?.businessId;
		this.appleBusiness = null;
		getAppleBusiness(this.place['apple']?.businessId).then(business => {
			this.appleBusiness = business;
		});
		this.appleFeedback = null;
		getAppleFeedback(this.place._id).then(feedback => {
			this.appleFeedback = feedback;
		});
		this.pendingPublish = res.data.google?.validation?.markedForPublication;
		this.loading = false;
		this.isBingPublished = this.place?.bing?.businessStatus?.BusinessStatus === 'Published';
		this.isPtvPublished = this.place?.ptv?.idSetType === 'approved';
		const country = this.place?.address?.country;
		const enabledNetworks = pmtEnabledNetworksService.get(this.selectedSite, country);
		Object.assign(this, enabledNetworks);
	};

	this.$onInit = () => {
		locationDataService.subscribe(site, placeId, 'pmtLocationNetworkStatus', bindPlace);
	};

	this.disconnectNetwork = network => {
		const url = `api/${encodeURI(site)}/place/${this.place._id}/disconnect${network}`;
		$http.post(url, {}).then(
			() => locationDataService.get(site, placeId).then(bindPlace),
			err => console.error(err)
		);
	};

	this.refetchGoogle = () => {
		this.refetchingGoogle = true;
		const url = `api/${encodeURI(site)}/place/${this.place._id}/google/refetch`;
		$http
			.post(url, {})
			.catch(err => console.error(err))
			.finally(() => {
				this.refetchingGoogle = false;
			});
	};

	$scope.fbWebhookStatus = function (place) {
		const isWebhookSubscribed = place.fb && place.fb.data && place.fb.data.isWebhookSubscribed;
		const subscribed = place.fb && place.fb.webhook && place.fb.webhook.subscribed;

		const date = subscribed ? new Date(place.fb.webhook.subscribed) : null;
		const stringDate = date ? date.toISOString().slice(0, 19).replace('T', ' ') : '';

		const webhookStatus = isWebhookSubscribed
			? $i18next.t('listings.brand_pages.confirmed')
			: subscribed
				? $i18next.t('listings.brand_pages.subscribed') + ' ' + stringDate
				: $i18next.t('listings.brand_pages.not_activated');

		return $i18next.t('listings.brand_pages.webhook') + ': ' + webhookStatus;
	};

	$scope.appleHelpText = function () {
		const timeSpan = $i18next.t('listings.location_detail.apple_update_time_span');

		return $i18next.t('listings.location_detail.apple_help_text', {
			time_span: `<strong>${timeSpan}</strong>`,
			apple_maps: '<strong>Apple Maps</strong>'
		});
	};

	const missingAppleRequiredFields = () => {
		const item = this.place;
		const networkCategory = item.networkCategories.apple?.primary?.id;
		const appleCategory = auth.user.selectedSite.places.apple.categories?.primaryCategory?.id;

		const fieldChecks = [
			{
				check: !!(item.apple?.custom?.name || item.name),
				message: 'listings.location_detail.storefront_name'
			},
			{
				check: item.location?.lat && item.location?.lon,
				message: 'listings.location_detail.geo_coordinates'
			},
			{
				check: !!(networkCategory || appleCategory),
				message: 'listings.location_detail.categories_apple'
			},
			{
				check: item.address?.countryAlpha2Code && item.address?.city,
				message: 'listings.location_detail.location_address'
			}
		];

		return fieldChecks.filter(({ check }) => !check).map(({ message }) => $i18next.t(message));
	};

	$scope.appleNotConnectedMessage = () => {
		const isNotSupportedCountry = ['CN', 'CU', 'KP', 'KR', 'RU', 'BY', 'IR', 'SY', 'UA'].includes(
			this.place.address.countryAlpha2Code
		);
		if (isNotSupportedCountry) {
			return $i18next.t('listings.location_detail.apple_country_not_supported');
		}
		if (this.place.type === 'serviceArea') {
			return $i18next.t('listings.location_detail.apple_must_be_storefront');
		}
		const missingFields = missingAppleRequiredFields();
		if (missingFields.length) {
			return (
				$i18next.t('listings.location_detail.apple_missing_information') +
				' (' +
				missingFields.join(', ') +
				')'
			);
		}

		return $i18next.t('listings.location_detail.pending_claim');
	};

	$scope.appleNotConnectedIcon = () => {
		const missingFields = missingAppleRequiredFields();
		const isNotSupportedCountry = ['CN', 'CU', 'KP', 'KR', 'RU', 'BY', 'IR', 'SY', 'UA'].includes(
			this.place.address.countryAlpha2Code
		);

		if (isNotSupportedCountry || this.place.type !== 'storefront' || missingFields.length) {
			return 'note';
		}

		return 'pending-note';
	};

	$scope.bingHelpText = function () {
		const timeSpan = $i18next.t('listings.location_detail.bing_update_time_span');

		return $i18next.t('listings.location_detail.bing_help_text', {
			time_span: `<strong>${timeSpan}</strong>`,
			bing: '<strong>Bing</strong>'
		});
	};

	$scope.appleStatus = function () {
		return $i18next.t('listings.location_detail.apple_status', {
			apple: '<strong>Apple</strong>'
		});
	};

	$scope.formatBingQualityIssues = function (qualityIssues) {
		return qualityIssues.map(x => x.IssueType).join(', ');
	};

	$scope.formatAppleFeedbackReports = function (reports) {
		return reports.map(report => report.message || report.code).join(', ');
	};

	$scope.formatBingDate = function (date) {
		if (!date || new Date(date).getFullYear() < 1900) {
			return 'Never';
		}
		return date;
	};

	$scope.bingPublishedStatus = function (bingStatus) {
		switch (bingStatus) {
			case 'Published':
				return $i18next.t('listings.directories.published_status');
			case 'PublishInProgress':
				return $i18next.t('listings.directories.in_progress_status');
			default:
				return '';
		}
	};

	$scope.ptvPublishedStatus = function (isPublished) {
		return isPublished
			? $i18next.t('listings.directories.published_status')
			: $i18next.t('listings.directories.not_published_status');
	};

	$scope.ptvHelpText = function () {
		const timeSpan = $i18next.t('listings.location_detail.ptv_update_time_span');

		return $i18next.t('listings.location_detail.ptv_help_text', {
			time_span: `<strong>${timeSpan}</strong>`,
			ptv: '<strong>PTV</strong>'
		});
	};
}

angular.module('pmtPlacesApp.controllers').component(componentName, {
	templateUrl: `components/location/${componentName}.html`,
	controller: Controller
});
Controller.$inject = [
	'$scope',
	'$http',
	'$i18next',
	'$stateParams',
	'auth',
	'pmtEnabledNetworksService',
	'pmtLocationDataService'
];
